import { render, staticRenderFns } from "./UnGapTest.vue?vue&type=template&id=c6cb6eb2&"
import script from "./UnGapTest.vue?vue&type=script&lang=js&"
export * from "./UnGapTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports